package com.fireavert.units.list_unit.client.presentation

import com.fireavert.buildings.data_models.data_model.BuildingObject
import com.fireavert.units.shared.data_models.UnitModel
data class UnitsSectionViewState(
    val unitModels: List<UnitModel> = emptyList(),
    val loading: Boolean = true,
    val showAddUnit: Boolean = false,
    val showEditUnit: Boolean = false,
    val showDeleteUnit: Boolean = false,
    val buildingList: List<BuildingObject> = emptyList(),
)
